import { saveEventOnAnalytics } from '../../../../../../utils/helpers'

class ReclassificacaoFiscalEstatisticas {
    static get $inject() {
        return ['$scope', 'ReclassificacaoFiscal']
    }

    constructor($scope, ReclassificacaoFiscal) {
        this.apply = fn => $scope.$apply(fn)
        this.watch = (...args) => $scope.$watch(...args)
        this.ReclassificacaoFiscal = ReclassificacaoFiscal

        this.conclusoesComProblemas = ['CLASSIFICACAO_INCORRETA', 'REPROVADO']

        this.produtoFilter = {}
        this.selected = 'TODOS'
        this.selectedPath = ['TODOS']
    }

    $onInit() {
        this.watch(() => this.currentTab, newValue => {
            if (newValue) {
                this.selectedPath = [newValue]
                this.selected = newValue
            }
        })

        this.changesNotifier.subscribe(() => {
            if (this.filialId) {
                this.loadEstatisticas(this.filialId, this.produtoFilter)
            }
        })

        this.filterNotifier.subscribe(filter => {
            if (this.filialId && filter) {
                const { hasReclassificacao, filialId, order, ...produtoFilter } = filter
                
                if (this.hasProblemas) {
                    produtoFilter.hasReclassificacao = { conclusao: this.conclusoesComProblemas }
                }

                if (!angular.equals(this.produtoFilter, produtoFilter)) {
                    this.produtoFilter = produtoFilter
                    this.loadEstatisticas(this.filialId, this.produtoFilter)
                }
            }
        })
    }

    loadEstatisticas(filialId, filter = {}) {
        this.promise = this.ReclassificacaoFiscal
            .aggregateByConclusao(filialId, filter)
            .then(estatisticas => {
                this.estatisticas = estatisticas
                this.conclusaoTree = this.ReclassificacaoFiscal.buildConclusaoTree(estatisticas)
                this.selectedPath = this.findConclusaoWithResultPath(this.conclusaoTree)

                this.ngModelCtrl.$render = () => {
                    if (this.ngModelCtrl.$viewValue) {
                        this.select(this.ngModelCtrl.$viewValue)
                    }
                }
            })
            .catch(console.error)
            .finally(() => this.apply())
    }

    toggle(menu) {
        this.isSelected(menu) ? this.deselect(menu) : this.select(menu)
    }

    select(menu) {
        if (this.selected !== menu) {
            this.selectedPath = this.findPathToStatus(this.conclusaoTree, menu)
            this.selected = menu

            this.setViewValue(this.selected)
            saveEventOnAnalytics('ReclassificaoFiscalMaisBuscada', `${this.filialId} | ${menu}`)
        }
    }

    deselect(menu) {
        if (this.isSelected(menu)) {
            this.selectedPath = this
                .findPathToStatus(this.conclusaoTree, menu)
                .reject(p => p === menu)

            this.selected = this.selectedPath.last()

            this.setViewValue(this.selected)
        }
    }

    isSelected(menu) {
        return this.selectedPath.includes(menu)
    }

    findConclusaoWithResultPath(tree, path = []) {
        const entries = Object
            .entries(tree || {})
            .reject(([key, _value]) => key === 'TODOS')
            .filter(([_key, {count}]) => count > 0)

        if (entries.length === 1) {
            return entries.flatMap(([key, {children}]) => 
                this.findConclusaoWithResultPath(children, [...path, key])
            )
        } else {
            return path.length ? path : ['TODOS']
        }
    }

    percentual(item) {
        return this.estatisticas && this.estatisticas.total
            ? item * 100 / this.estatisticas.total
            : 0
    }

    findPathToStatus(tree, status, path = []) {
        if (!tree) return []
        if (tree.hasOwnProperty(status)) return [...path, status]

        return Object
            .entries(tree)
            .flatMap(([key, { children }]) => this.findPathToStatus(children, status, [...path, key]))
    }

    hasProblemasCheck() {
        this.setViewValue(this.selected)
    }

    setViewValue(value) {
        let conclusao = value === 'TODOS' ? [] : [value]

        if (this.hasProblemas) {
            conclusao = [...conclusao, ...this.conclusoesComProblemas]
        }

        this.ngModelCtrl.$setViewValue(conclusao)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('reclassificacaoFiscalEstatisticas', {
        controller: ReclassificacaoFiscalEstatisticas,
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            filialId: '<',
            currentTab: '<',
            changesNotifier: '<',
            filterNotifier: '<'
        },
        template: `
        <div class="reclassificacao-fiscal">
            <label>Classificação fiscal de itens</label>
            <div style="display: flex;">
                <div class="reclassificacao-fiscal-tabs">
                    <div 
                        ng-class="{'active': $ctrl.isSelected('TODOS')}"
                        ng-click="$ctrl.select('TODOS')">
                        <span>TODOS</span>
                        <span>{{$ctrl.estatisticas.total}}</span>
                    </div>

                    <div 
                        ng-class="{'active': $ctrl.isSelected('APROVADO')}" 
                        ng-click="$ctrl.select('APROVADO')">
                        <span>APROVADOS</span>
                        <span>
                            {{$ctrl.estatisticas.aprovado}}
                            (<span class="text-success">{{$ctrl.percentual($ctrl.estatisticas.aprovado) | number: 2}}%</span>)
                        </span>
                    </div>
                    <div 
                        ng-class="{'active': $ctrl.isSelected('REPROVADO')}"
                        ng-click="$ctrl.select('REPROVADO')">
                        <span>REPROVADOS</span>
                        <span>
                            {{$ctrl.estatisticas.reprovado}}
                            (<span class="text-danger">{{$ctrl.percentual($ctrl.estatisticas.reprovado) | number: 2}}%</span>)
                        </span>
                    </div>
                </div>
                <div style="margin-left: 10px; margin-bottom: 10px;">
                    <label>
                        <input 
                            type="checkbox" 
                            class="checkbox" 
                            ng-model="$ctrl.hasProblemas"
                            ng-change="$ctrl.hasProblemasCheck()"/>
                        <span> Exibir apenas itens que necessitam de alteração no cadastro</span>
                    </label>
                </div>
            </div>
            <div class="reclassificacao-fiscal-menu repeat-animation" ng-if="$ctrl.isSelected('APROVADO')">
                <span class="menu-item" ng-if="!$ctrl.hasProblemas">
                    <a 
                        href="javascript:void(0)" 
                        ng-class="{'is-selected': $ctrl.isSelected('NAO_RECLASSIFICADO')}"
                        ng-click="$ctrl.toggle('NAO_RECLASSIFICADO')">
                        Itens mantidos conforme dados do cliente
                    </a>
                    <b>{{$ctrl.estatisticas.naoReclassificado}}</b>
                </span>    
                
                <span class="menu-item" ng-if="!$ctrl.hasProblemas">
                    <a 
                        href="javascript:void(0)"
                        ng-class="{'is-selected': $ctrl.isSelected('NCM_DISPENSA_CODIGO_BARRAS')}"
                        ng-click="$ctrl.toggle('NCM_DISPENSA_CODIGO_BARRAS')">
                        Itens com NCM que não exige código de barras
                    </a>
                    <b>{{$ctrl.estatisticas.ncmDispensaCodigoBarras}}</b>
                </span>     
                <span class="menu-item" >
                    <a 
                        href="javascript:void(0)" 
                        ng-class="{'is-selected': $ctrl.isSelected('RECLASSIFICADO')}" 
                        ng-click="$ctrl.toggle('RECLASSIFICADO')">
                        Itens processados via código de barras
                    </a>
                    <b ng-show="!$ctrl.hasProblemas">{{$ctrl.estatisticas.reclassificado}}</b>
                    <b ng-hide="!$ctrl.hasProblemas">{{$ctrl.estatisticas.classificacaoIncorreta}}</b>
                </span>
                
                <div class="reclassificacao-fiscal-menu submenu repeat-animation" ng-if="$ctrl.isSelected('RECLASSIFICADO')">
                    <span class="menu-item" ng-if="!$ctrl.hasProblemas">
                        <a 
                            href="javascript:void(0)"
                            ng-class="{'is-selected': $ctrl.isSelected('CLASSIFICACAO_CORRETA')}"
                            ng-click="$ctrl.toggle('CLASSIFICACAO_CORRETA')">
                            Itens com classificação mantida
                        </a>
                        <b>{{$ctrl.estatisticas.classificacaoCorreta}}</b>
                    </span>
                    <span class="menu-item">
                        <a 
                            href="javascript:void(0)"
                            ng-class="{'is-selected': $ctrl.isSelected('CLASSIFICACAO_INCORRETA')}"
                            ng-click="$ctrl.toggle('CLASSIFICACAO_INCORRETA')">
                            Itens reclassificados 
                        </a>
                        <b>{{$ctrl.estatisticas.classificacaoIncorreta}}</b>
                    </span>                      
                    <div class="reclassificacao-fiscal-menu submenu repeat-animation" ng-if="$ctrl.isSelected('CLASSIFICACAO_INCORRETA')">
                        <span class="menu-item">
                            <a 
                                href="javascript:void(0)"
                                ng-class="{'is-selected': $ctrl.isSelected('NCM_DIVERGENTE')}"
                                ng-click="$ctrl.toggle('NCM_DIVERGENTE')">
                                NCM divergente</a>
                            <b>{{$ctrl.estatisticas.ncmDivergente}}</b>
                        </span>
                        <span class="menu-item">
                            <a 
                                href="javascript:void(0)"
                                ng-class="{'is-selected': $ctrl.isSelected('EX_TIPI_DIVERGENTE')}"
                                ng-click="$ctrl.toggle('EX_TIPI_DIVERGENTE')">
                                EX TIPI divergente</a>
                            <b>{{$ctrl.estatisticas.exTipiDivergente}}</b>
                        </span>
                        <span class="menu-item">
                            <a 
                                href="javascript:void(0)"
                                ng-class="{'is-selected': $ctrl.isSelected('CEST_DIVERGENTE')}"
                                ng-click="$ctrl.toggle('CEST_DIVERGENTE')">
                                CEST divergente</a>
                            <b>{{$ctrl.estatisticas.cestDivergente}}</b>
                        </span>
                    </div>
                </div>
            </div>

            <div class="reclassificacao-fiscal-menu repeat-animation" ng-if="$ctrl.isSelected('REPROVADO')">
                <span class="menu-item">
                    <a 
                        href="javascript:void(0)"
                        ng-class="{'is-selected': $ctrl.isSelected('INVALID_CODIGO_BARRAS')}"
                        ng-click="$ctrl.toggle('INVALID_CODIGO_BARRAS')">
                        Itens com código de barras inválido
                    </a>
                    <b>{{$ctrl.estatisticas.invalidCodigoBarras}}</b>
                </span>    
                
                <span class="menu-item">
                    <a 
                        href="javascript:void(0)"
                        ng-class="{'is-selected': $ctrl.isSelected('MISSING_CODIGO_BARRAS')}"
                        ng-click="$ctrl.toggle('MISSING_CODIGO_BARRAS')">
                        Itens sem código de barras
                    </a>
                    <b>{{$ctrl.estatisticas.missingCodigoBarras}}</b>
                </span>
                
                <span class="menu-item">
                    <a 
                        href="javascript:void(0)"
                        ng-class="{'is-selected': $ctrl.isSelected('PARAMETROS_INCONSISTENTES')}"
                        ng-click="$ctrl.toggle('PARAMETROS_INCONSISTENTES')">
                        Item com NCM, EX TIPI ou CEST inválido
                    </a>
                    <b>{{$ctrl.estatisticas.parametrosInconsistentes}}</b>
                </span>   
                
                <div class="reclassificacao-fiscal-menu submenu repeat-animation" ng-if="$ctrl.isSelected('PARAMETROS_INCONSISTENTES')">
                    <span class="menu-item">
                        <a 
                            href="javascript:void(0)"
                            ng-class="{'is-selected': $ctrl.isSelected('NCM_INVALIDA')}"
                            ng-click="$ctrl.toggle('NCM_INVALIDA')">
                            NCM inválida</a>
                        <b>{{$ctrl.estatisticas.ncmInvalida}}</b>
                    </span>
                    <span class="menu-item">
                        <a 
                            href="javascript:void(0)"
                            ng-class="{'is-selected': $ctrl.isSelected('EX_TIPI_INVALIDA')}"
                            ng-click="$ctrl.toggle('EX_TIPI_INVALIDA')">
                            EX TIPI inválida</a>
                        <b>{{$ctrl.estatisticas.exTipiInvalida}}</b>
                    </span>
                    <span class="menu-item">
                        <a 
                            href="javascript:void(0)"
                            ng-class="{'is-selected': $ctrl.isSelected('CEST_INVALIDO')}"
                            ng-click="$ctrl.toggle('CEST_INVALIDO')">
                            CEST inválido</a>
                        <b>{{$ctrl.estatisticas.cestInvalido}}</b>
                    </span>
                </div>
            </div>
        </div>
        `
    })
